import React, { useEffect, useState } from "react";
import { MessageCircle, X, ArrowUpRight, Clock3 } from "lucide-react";
import styles from "../styles/WhatsAppChat.module.css";

const WHATSAPP_NUMBER = "2349165387780";

export default function WhatsAppChat() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const timer = window.setTimeout(() => setOpen(true), 9000);
    return () => window.clearTimeout(timer);
  }, []);

  const startChat = (text = message) => {
    const clean = (text || "Hello Dey Fresh Signature, I would like to make an enquiry.").trim();
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(clean)}`, "_blank", "noopener,noreferrer");
  };

  return (
    <aside className={`${styles.widget} ${open ? styles.open : ""}`} aria-label="WhatsApp chat">
      {open && (
        <div className={styles.panel} role="dialog" aria-label="Chat with Dey Fresh Signature on WhatsApp">
          <div className={styles.header}>
            <div className={styles.avatar}>DF<span /></div>
            <div><strong>Dey Fresh Signature</strong><small><i /> Typically replies on WhatsApp</small></div>
            <button onClick={() => setOpen(false)} aria-label="Close WhatsApp chat"><X size={18}/></button>
          </div>
          <div className={styles.body}>
            <span className={styles.today}>TODAY</span>
            <div className={styles.bubble}>
              <small>DEY FRESH SIGNATURE</small>
              <p>Hello 👋 Welcome to Dey Fresh Signature. Prefer to chat instead of booking online?</p>
              <p>Send us a WhatsApp message and our team can help with services, appointments or home service enquiries.</p>
            </div>
            <div className={styles.hours}><Clock3 size={13}/> Mon–Sat 9am–8pm · Sun 1pm–8pm</div>
          </div>
          <div className={styles.quickReplies}>
            <button onClick={() => startChat("Hello Dey Fresh Signature, I would like to book an appointment.")}>Book by WhatsApp</button>
            <button onClick={() => startChat("Hello Dey Fresh Signature, I need help choosing a service.")}>Ask about a service</button>
            <button onClick={() => startChat("Hello Dey Fresh Signature, I would like to enquire about home service.")}>Home service</button>
          </div>
          <div className={styles.composer}>
            <input value={message} onChange={(e) => setMessage(e.target.value)} onKeyDown={(e) => e.key === "Enter" && startChat()} placeholder="Type your message..." aria-label="WhatsApp message" />
            <button onClick={() => startChat()} aria-label="Continue on WhatsApp"><ArrowUpRight size={18}/></button>
          </div>
          <div className={styles.powered}>Opens securely in WhatsApp</div>
        </div>
      )}
      <button className={styles.launcher} onClick={() => setOpen((value) => !value)} aria-expanded={open} aria-label={open ? "Close WhatsApp chat" : "Chat with us on WhatsApp"}>
        {open ? <X size={23}/> : <MessageCircle size={25}/>}<span>Chat with us</span>
      </button>
    </aside>
  );
}
